/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $('.js-tab__label').on('click', function() {
    $(this).toggleClass('js-tab__label--active');
    return $(this).parents('.js-tab').find('.js-tab__content').toggleClass('js-tab__content--active');
  });

  if ($('.accordian-wrap').hasClass('faq')) {
    $('.faq h3 + h4, .faq h3 + p, .faq h3 + ul, .faq h3 + ol, .faq h3 + figure').each(function() {
      $(this).nextUntil('h3').addBack().wrapAll('<div class=\'faq-content\' />');
    });
  }

  $('.faq .accordian-wrap-rm h3').on('click', function() {
    if ($(this).next('.faq-content').hasClass('open-faq')) {
      $(this).next('.faq-content').removeClass('open-faq');
      return $(this).removeClass('faq-heading-open');
    } else {
      $(this).next('.faq-content').addClass('open-faq');
      return $(this).addClass('faq-heading-open');
    }
  });

  $('body').on('keyup', function(e) {
    if (e.which === 9) {
      $('body').addClass('tabbycat');
    }
  });
  $('body').on('click', function(e) {
    $('body').removeClass('tabbycat');
  });

  return $('.menu .menu__categories .mp-menu-cat').keypress(function(event) {
    if (event.keyCode === 13) {
      if ($(this)) {
        $(this).siblings('input[type=radio]').prop('checked', true);
      } else {
        $('.menu .menu__categories .mp-menu-cat').siblings('input[type=radio]').prop('checked', false);
      }
      event.preventDefault();
    }
  });
});
